var map = {
	"./EY__bg_md.png": "5db8",
	"./EY__wavespace_md.png": "ccec",
	"./GSK_bg_md.png": "2cc6",
	"./ey-carousel/blockchain_md.png": "de29",
	"./ey-carousel/changying_md.png": "f3cb",
	"./ey-carousel/move_md.png": "ea0b",
	"./ey-carousel/summary_md.png": "d979",
	"./ey-carousel/timelines_md.png": "cfa4",
	"./gsk/ex-tasks_md.png": "5e3f",
	"./gsk/ex-timeline_md.png": "b598",
	"./home-duckrabbit_md.png": "e274",
	"./useful-carousel/aidmodel_md.png": "1d8e",
	"./useful-carousel/articletop_md.png": "dc23",
	"./useful-carousel/hometile_md.png": "0fb1",
	"./useful-carousel/hometop_md.png": "52fb",
	"./useful-carousel/managertips_md.png": "38e7",
	"./useful-carousel/thingstotry_md.png": "956b",
	"./useful_hero_md.png": "5764"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be80";